import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

export const getACHAuthorizationRecords = async (userId) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get(
    `/payment/admin/account/payment-method/${userId}/authorization-record`,
    { headers },
  );

  return response.data;
};
